import { useMemo } from "react";

import type { IIabCategoryItemDescriptionDto } from "../../../../types/descriptionDto";

function useIabCategoriesById(
    options: readonly IIabCategoryItemDescriptionDto[],
): Record<string, IIabCategoryItemDescriptionDto> {
    return useMemo(() => options.reduce((acum, item) => ({ ...acum, [item.id]: item }), {}), [options]);
}

export default useIabCategoriesById;
